import { Component } from "react";
import VectorLayer from "ol/layer/Vector";



class SearchOverlay extends Component {

  state = {
    tileSource: null
  };

  componentDidMount() {

  }

  componentDidUpdate() {
    let { map, vectorSource } = this.props;

    const vectorLayer = new VectorLayer({
      source: vectorSource,
    });

    map.addLayer(vectorLayer);

    map.on('moveend', () => {
      if(vectorSource.getFeatures().length > 0) {
        vectorSource.clear();
      }
    });

  };

  render() {
    return false;
  }
}


export default SearchOverlay;
